import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Modal, Drawer, Select, Dropdown, Menu } from 'antd';
// import { Link } from 'react-router-dom';
const { Option } = Select;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        return (
            <div className={css.content} >
                <iframe 
                    name={'myiframe'}
                    id={'printingId'}
                    src={this.modulesState.previewUrl}
                    style={{width: '1052px', height: '800px', border: '0px'}}
                >
                </iframe>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/PreviewPublic/UI.Content.tsx